/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CapitalActivityEditScreenData
} from '../../model/capitalActivityEditScreenData'
import type {
  CapitalActivityInvestorOverviewRetrieveParams
} from '../../model/capitalActivityInvestorOverviewRetrieveParams'
import type {
  CapitalActivitySummaryData
} from '../../model/capitalActivitySummaryData'
import type {
  CapitalActivityTableDataRetrieveParams
} from '../../model/capitalActivityTableDataRetrieveParams'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  TransactionFeesSummaryTableRetrieveParams
} from '../../model/transactionFeesSummaryTableRetrieveParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get the capital activity based on the query parameters as GenericTableData
 */
export const capitalActivityTableDataRetrieve = (
    params?: CapitalActivityTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/capital-activity/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCapitalActivityTableDataRetrieveQueryKey = (params?: CapitalActivityTableDataRetrieveParams,) => {
    return [`/capital-activity/`, ...(params ? [params]: [])] as const;
    }

    
export const getCapitalActivityTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError = unknown>(params?: CapitalActivityTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalActivityTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>> = ({ signal }) => capitalActivityTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalActivityTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>>
export type CapitalActivityTableDataRetrieveQueryError = unknown

export const useCapitalActivityTableDataRetrieve = <TData = Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError = unknown>(
 params?: CapitalActivityTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalActivityTableDataRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCapitalActivityTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError = unknown>(params?: CapitalActivityTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalActivityTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>> = ({ signal }) => capitalActivityTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalActivityTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>>
export type CapitalActivityTableDataRetrieveSuspenseQueryError = unknown

export const useCapitalActivityTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError = unknown>(
 params?: CapitalActivityTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivityTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalActivityTableDataRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCapitalActivityTableDataRetrieveLoader = (queryParamsOrFn?: (CapitalActivityTableDataRetrieveParams | ((params: Params) => CapitalActivityTableDataRetrieveParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getCapitalActivityTableDataRetrieveQueryKey(queryParams),
            queryFn: () => capitalActivityTableDataRetrieve(queryParams),
          }).then(() => null);
        });
      /**
 * Returns a summary of all capital activity for a given fund family
 */
export const capitalActivitySummaryRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CapitalActivitySummaryData>(
      {url: `/fund-family/${fundFamilyId}/capital-activity`, method: 'GET', signal
    },
      options);
    }
  

export const getCapitalActivitySummaryRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/capital-activity`] as const;
    }

    
export const getCapitalActivitySummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalActivitySummaryRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>> = ({ signal }) => capitalActivitySummaryRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalActivitySummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>>
export type CapitalActivitySummaryRetrieveQueryError = unknown

export const useCapitalActivitySummaryRetrieve = <TData = Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalActivitySummaryRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCapitalActivitySummaryRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalActivitySummaryRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>> = ({ signal }) => capitalActivitySummaryRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalActivitySummaryRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>>
export type CapitalActivitySummaryRetrieveSuspenseQueryError = unknown

export const useCapitalActivitySummaryRetrieveSuspense = <TData = Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivitySummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalActivitySummaryRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCapitalActivitySummaryRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCapitalActivitySummaryRetrieveQueryKey(fundFamilyId),
              queryFn: () => capitalActivitySummaryRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Returns details for the edit screen for a given capital activity event
 */
export const capitalActivityEventRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CapitalActivityEditScreenData>(
      {url: `/fund-family/${fundFamilyId}/capital-activity/${fundFamilyEventId}/edit`, method: 'GET', signal
    },
      options);
    }
  

export const getCapitalActivityEventRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/capital-activity/${fundFamilyEventId}/edit`] as const;
    }

    
export const getCapitalActivityEventRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalActivityEventRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>> = ({ signal }) => capitalActivityEventRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalActivityEventRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>>
export type CapitalActivityEventRetrieveQueryError = unknown

export const useCapitalActivityEventRetrieve = <TData = Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalActivityEventRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCapitalActivityEventRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalActivityEventRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>> = ({ signal }) => capitalActivityEventRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalActivityEventRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>>
export type CapitalActivityEventRetrieveSuspenseQueryError = unknown

export const useCapitalActivityEventRetrieveSuspense = <TData = Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivityEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalActivityEventRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCapitalActivityEventRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCapitalActivityEventRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => capitalActivityEventRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the fees summary table
 */
export const transactionFeesSummaryTableRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: TransactionFeesSummaryTableRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/capital-activity/${fundFamilyEventId}/fees-summary-table/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getTransactionFeesSummaryTableRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: TransactionFeesSummaryTableRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/capital-activity/${fundFamilyEventId}/fees-summary-table/`, ...(params ? [params]: [])] as const;
    }

    
export const getTransactionFeesSummaryTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: TransactionFeesSummaryTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionFeesSummaryTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>> = ({ signal }) => transactionFeesSummaryTableRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionFeesSummaryTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>>
export type TransactionFeesSummaryTableRetrieveQueryError = unknown

export const useTransactionFeesSummaryTableRetrieve = <TData = Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: TransactionFeesSummaryTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionFeesSummaryTableRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTransactionFeesSummaryTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: TransactionFeesSummaryTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionFeesSummaryTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>> = ({ signal }) => transactionFeesSummaryTableRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionFeesSummaryTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>>
export type TransactionFeesSummaryTableRetrieveSuspenseQueryError = unknown

export const useTransactionFeesSummaryTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: TransactionFeesSummaryTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionFeesSummaryTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionFeesSummaryTableRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTransactionFeesSummaryTableRetrieveLoader = (queryParamsOrFn?: (TransactionFeesSummaryTableRetrieveParams | ((params: Params) => TransactionFeesSummaryTableRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getTransactionFeesSummaryTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => transactionFeesSummaryTableRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Returns an investor overview of capital activity for a given fund family
 */
export const capitalActivityInvestorOverviewRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalActivityInvestorOverviewRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/capital-activity/${fundFamilyEventId}/investor-overview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCapitalActivityInvestorOverviewRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalActivityInvestorOverviewRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/capital-activity/${fundFamilyEventId}/investor-overview`, ...(params ? [params]: [])] as const;
    }

    
export const getCapitalActivityInvestorOverviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalActivityInvestorOverviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalActivityInvestorOverviewRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>> = ({ signal }) => capitalActivityInvestorOverviewRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalActivityInvestorOverviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>>
export type CapitalActivityInvestorOverviewRetrieveQueryError = unknown

export const useCapitalActivityInvestorOverviewRetrieve = <TData = Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalActivityInvestorOverviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalActivityInvestorOverviewRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCapitalActivityInvestorOverviewRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalActivityInvestorOverviewRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalActivityInvestorOverviewRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>> = ({ signal }) => capitalActivityInvestorOverviewRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalActivityInvestorOverviewRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>>
export type CapitalActivityInvestorOverviewRetrieveSuspenseQueryError = unknown

export const useCapitalActivityInvestorOverviewRetrieveSuspense = <TData = Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalActivityInvestorOverviewRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalActivityInvestorOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalActivityInvestorOverviewRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCapitalActivityInvestorOverviewRetrieveLoader = (queryParamsOrFn?: (CapitalActivityInvestorOverviewRetrieveParams | ((params: Params) => CapitalActivityInvestorOverviewRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCapitalActivityInvestorOverviewRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => capitalActivityInvestorOverviewRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      